(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-new"] && !Shopify.designMode) return;
  try {
    

    $(document).ready(function () {
      
  $('.faq-areaa:not(.faq-body-areaa)').click(function () { 
    $(this).toggleClass('active-faq');
    $(this).find('.faq-body-areaa').toggle('fast');
});


jQuery(function($) {
    var num_cols = 2,
    container = jQuery('.faq-wraps-area'),
    listItem = '.faq-areaa',
    listClass = 'sub-list';
    container.each(function() {
        var items_per_col = new Array(),
        items = $(this).find(listItem),
        min_items_per_col = Math.floor(items.length / num_cols),
        difference = items.length - (min_items_per_col * num_cols);
        for (var i = 0; i < num_cols; i++) {
            if (i < difference) {
                items_per_col[i] = min_items_per_col + 1;
            } else {
                items_per_col[i] = min_items_per_col;
            }
        }
        for (var i = 0; i < num_cols; i++) {
            jQuery(this).append($('<div></div>').addClass(listClass));
            for (var j = 0; j < items_per_col[i]; j++) {
                var pointer = 0;
                for (var k = 0; k < i; k++) {
                    pointer += items_per_col[k];
                }
                jQuery(this).find('.' + listClass).last().append(items[j + pointer]);
            }
        }
    });
});
 
      });   
  

  } catch(e) { console.error(e); }
})();
})();
